export default "__VITE_ASSET__DftFCYHF__"